"use client"

import { forwardRef, type SelectHTMLAttributes } from "react"

import { cn } from "../lib/cn"

export const NativeSelect = forwardRef<HTMLSelectElement, SelectHTMLAttributes<HTMLSelectElement>>(
  ({ className, children, ...props }, ref) => (
    <select
      ref={ref}
      data-slot="native-select"
      className={cn("h-9 w-full rounded-md border border-input bg-background px-3 text-sm text-foreground outline-none focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 disabled:opacity-50 aria-invalid:border-destructive", className)}
      {...props}
    >
      {children}
    </select>
  ),
)
NativeSelect.displayName = "NativeSelect"
